import { useHistory } from "react-router";
import { VehicleNames } from "../../../utils/GeneralTypes";
import { FormatPrice } from "../../../utils/generalUtils";
import { Check, Minus, Plus, XMark } from "../../Icons";
import style from "./index.module.css";
import { useTranslation } from "../../../hooks/useTranslation";

const CompareTable = ({
  vehicles,
  attributes,
  vehicleNames,
  vehicleState,
  removeVehicle,
  addVehicle,
}: ComponentPropsType) => {
  const { locale } = useTranslation();

  const history = useHistory();

  return (
    <table className={style.compare_table}>
      <tbody>
        <tr>
          <td>{locale(vehicleNames.single)}</td>
          {[1, 2, 3].map((_, index) =>
            vehicles?.[index] ? (
              <td key={index}>
                {vehicles?.[index]?.images?.[0]?.image && <img src={vehicles[index].images[0].image} alt="" />}
                <button className={style.remove_vehicle_btn} onClick={() => removeVehicle(vehicles[index].id)}>
                  <Minus width="20" height="20" color="#dc0000" />
                </button>
              </td>
            ) : (
              <td key={index}>
                <button
                  className={style.add_vehicle_btn}
                  onClick={() => history.push(`/${vehicleState}-${vehicleNames.plural}`)}
                >
                  <Plus width="30" height="30" color="#c2c7c7" />
                </button>
              </td>
            ),
          )}
        </tr>
        <tr>
          <td>{locale("model")}</td>
          {vehicles.map((vehicle: any) => (
            <td key={vehicle.id}>{vehicle.class_name}</td>
          ))}
        </tr>
        <tr>
          <td>{locale("price")}</td>
          {vehicles.map((vehicle: any) => (
            <td key={vehicle.id}>
              <FormatPrice value={vehicle.price} />
            </td>
          ))}
        </tr>
        {attributes.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {row.map((col: any, colIndex: number) => (
              <td key={colIndex}>
                {col === true || col === false ? (
                  col ? (
                    <Check width="15" height="15" color="#01BB00" />
                  ) : (
                    <XMark width="15" height="15" color="#FF0000" />
                  )
                ) : (
                  col
                )}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default CompareTable;

type ComponentPropsType = {
  vehicles: any[];
  attributes: [string, string][];
  vehicleNames: VehicleNames;
  vehicleState: "new" | "used" | "imported";
  removeVehicle: CallableFunction;
  addVehicle: CallableFunction;
};
